export default __webpack_public_path__ + "static/media/whatsapp.d9763762.svg";